import tw from 'twin.macro';

import { PencilIcon, TrashIcon } from '@heroicons/react/24/outline';

import { GetJobPositionsQuery } from '@/libs/graphql';

type JobPosition = GetJobPositionsQuery['getJobPositions'][number];

type Props = {
  positions: JobPosition[];
  isViewOnly: boolean;
  onEdit: (position: JobPosition) => void;
  onDelete: (position: JobPosition) => void;
};

const PositionsTable = ({ positions, isViewOnly, onEdit, onDelete }: Props) => {
  if (positions.length === 0) {
    return (
      <div tw="flex flex-col items-center justify-center py-12 text-gray-400">
        <p tw="text-sm">ยังไม่มีตำแหน่งงาน</p>
      </div>
    );
  }

  return (
    <div tw="overflow-x-auto">
      <table tw="w-full text-sm text-left">
        <thead tw="bg-gray-50 text-gray-600 text-xs uppercase">
          <tr>
            <th tw="px-4 py-3 w-1/4">ตำแหน่งงาน</th>
            <th tw="px-4 py-3">คำอธิบาย</th>
            {!isViewOnly && <th tw="px-4 py-3 w-24 text-right">จัดการ</th>}
          </tr>
        </thead>
        <tbody tw="divide-y divide-gray-100">
          {positions.map((position) => (
            <tr key={position.id} tw="hover:bg-gray-50 transition-colors duration-100">
              <td tw="px-4 py-3 font-medium text-gray-900">{position.title}</td>
              <td tw="px-4 py-3 text-gray-500 max-w-md">
                <p tw="line-clamp-2">{position.jobDescriptions}</p>
              </td>
              {!isViewOnly && (
                <td tw="px-4 py-3">
                  <div tw="flex justify-end gap-2">
                    <button
                      tw="p-1.5 rounded-lg text-gray-400 hover:(text-gray-600 bg-gray-100) transition-colors duration-100"
                      onClick={() => onEdit(position)}
                      title="แก้ไข"
                    >
                      <PencilIcon tw="w-4 h-4" />
                    </button>
                    <button
                      tw="p-1.5 rounded-lg text-gray-400 hover:(text-red-500 bg-red-50) transition-colors duration-100"
                      onClick={() => onDelete(position)}
                      title="ลบ"
                    >
                      <TrashIcon tw="w-4 h-4" />
                    </button>
                  </div>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PositionsTable;
